__turbopack_context__.v({
  "table-section": "C2kZLa_table-section",
  "table-section__count": "C2kZLa_table-section__count",
  "table-section__header": "C2kZLa_table-section__header",
  "table-section__pagination": "C2kZLa_table-section__pagination",
  "table-section__scroll": "C2kZLa_table-section__scroll",
  "table-section__sort-icon": "C2kZLa_table-section__sort-icon",
  "table-section__sort-icon--descending": "C2kZLa_table-section__sort-icon--descending",
  "table-section__table": "C2kZLa_table-section__table",
  "table-section__th-content": "C2kZLa_table-section__th-content",
  "table-section__title": "C2kZLa_table-section__title",
  "table-section__title-wrapper": "C2kZLa_table-section__title-wrapper",
});
